<div class="w-100-p" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="flex-end center" style="height: 56px">
    <div fxLayout="row" fxLayoutAlign="start center" class="px-12">
        <!-- Automation Report Icon -->
        @if (this.isSystemAdmin) {
            <button
                mat-icon-button
                (click)="openAutomationReport()"
                title="Automation Report"
                class="automation-report-icon"
            >
                <mat-icon>bar_chart</mat-icon>
            </button>
        }

        <!-- <img *ngIf="!getUserImage(40)" [src]="userInfo?.ProfileImage" class="avatar mr-0 mr-sm-16" alt="" /> -->
        <div class="not-auth-box" *ngIf="emailNotAuthorizedBox">
            <div>
                <span class="mr-8 font-weight-400 font-size-14" style="color: rgba(0, 10, 27, 0.8)">
                    {{ "PLEASE_AUTHORIZE" | translate }}
                </span>
                <button mat-button class="pl-12" (click)="onRedirect()">
                    <mat-icon
                        class="font-size-14 mr-4"
                        style="color: #00a780; background: none !important; height: 14px; width: 14px; line-height: 14px; display: inline-flex; align-items: center; justify-content: center;"
                    >
                        arrow_forward</mat-icon
                    >
                    <span class="font-weight-700 font-size-14 text-uppercase spaced-letter" style="color: #00a780; display: inline-flex; align-items: center;">
                        {{ "AUTHORIZE_NOW" | translate }}</span
                    >
                </button>
            </div>
        </div>
        <div class="not-auth-box p-12" *ngIf="emailAuthorizedBox">
            <div>
                <span class="font-weight-400 font-size-14" style="color: rgba(0, 10, 27, 0.8)">
                    {{ "AUTHORIZED" | translate }}
                </span>
            </div>
        </div>

        <div class="arrow" *ngIf="emailNotAuthorizedBox || emailAuthorizedBox"></div>

        <div class="notification-icon-wrapper">
            <button
                class="notification-icon"
                mat-icon-button
                [matMenuTriggerFor]="appNotification"
                matBadge="{{ totalUnreadMessage > 9 ? '9+' : totalUnreadMessage }}"
                [matBadgeHidden]="totalUnreadMessage === 0"
            >
                <mat-icon>notifications</mat-icon>
            </button>
        </div>

        <button
            mat-icon-button
            *ngIf="
                isShowEmailAuthTick &&
                mailAuthStatusService.isMailAuthorized === true &&
                currentRole !== currentUserRole.BackOffice
            "
            (click)="openAuthorizedTooltip()"
        >
            <mat-icon class="checked">verified</mat-icon>
        </button>
        <button
            mat-icon-button
            *ngIf="
                isShowEmailAuthTick &&
                mailAuthStatusService.isMailAuthorized === false &&
                currentRole !== currentUserRole.BackOffice
            "
            (click)="openNotAuthorizedTooltip()"
        >
            <mat-icon class="not-checked">new_releases_black</mat-icon>
        </button>

        <button [matMenuTriggerFor]="userMenu" class="user-button expand-area" mat-button>
            <ngx-avatar
                *ngIf="userInfo && !userInfo.ProfileImage"
                [round]="true"
                [bgColor]="userInfo.ColorCode"
                class="my-avatar"
                fgColor="#FFFFFF"
                initialsSize="1"
                [name]="userInfo.DisplayName"
                size="32"
                textSizeRatio="2.5"
                [value]="userInfo.DisplayName"
            >
            </ngx-avatar>
            <ngx-avatar
                class=""
                *ngIf="userInfo && userInfo.ProfileImage"
                [round]="true"
                [size]="32"
                bgColor="#DADADA"
                fgColor="#FFFFFF"
                initialsSize="1"
                src="{{ userInfo.ProfileImage }}"
                textSizeRatio="2.5"
            >
            </ngx-avatar>
            <span fxLayout="row" fxLayoutAlign="center center">
                <span class="toolbar-title mr-12" fxHide fxShow.gt-sm>{{ userInfo?.DisplayName || "USER NAME" }}</span>
                <mat-icon class="s-16 dropdown-icon hover-circle" fxHide.xs id="am-1363">keyboard_arrow_down</mat-icon>
            </span>
        </button>
    </div>

    <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
        <button [routerLink]="['/profile']" (click)="clickOnProfile()" mat-menu-item id="am-1364">
            <mat-icon>account_circle</mat-icon>
            <span>{{ "MY_PROFILE" | translate }}</span>
        </button>

        <button (click)="logout()" mat-menu-item id="am-1365">
            <mat-icon>exit_to_app</mat-icon>
            <span>{{ "LOG_OUT" | translate }}</span>
        </button>
    </mat-menu>
    <div class="toolbar-separator"></div>
    <button [matMenuTriggerFor]="languageMenu" class="language-button w-100 px-12 expand-area" mat-button id="am-1366">
        <span fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px">
            <!-- <img class="flag mr-8" [src]="'assets/images/flags/'+selectedLanguage.flag+'.png'">  -->
            <span class="toolbar-title text-uppercase">{{ selectedLanguage }}</span>
            <mat-icon class="s-16 dropdown-icon hover-circle" fxHide.xs>keyboard_arrow_down</mat-icon>
        </span>
    </button>
    <mat-menu #languageMenu="matMenu" [overlapTrigger]="false" id="am-1367">
        <button (click)="changeLang(lang.id)" *ngFor="let lang of languages" mat-menu-item>
            <span fxLayout="row" fxLayoutAlign="start center">
                <span class="iso">{{ lang.value | translate }}</span>
            </span>
        </button>
    </mat-menu>

    <mat-menu #appNotification="matMenu" [overlapTrigger]="false" class="notification-wrapper">
        <app-service-notification
            (applicationNotificationsEvent)="updateApplicationNotifications($event)"
        ></app-service-notification>
    </mat-menu>

    <!--<div class="toolbar-separator"></div>
    &lt;!&ndash;            {{usersOrgLogo}}&ndash;&gt;
    <a class="logo pl-32" href="#" *ngIf="usersOrgLogo">
        <img [src]="usersOrgLogo" class="toolbar-horizontal-logo" alt="" />
    </a>-->
</div>
